import { vars } from 'src/core/themes';

export const SHIMMERING_DIV_HEIGHT_PAYMENTS = vars.spacing.xxl;
